
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import BtnBase from "@components/Buttons/BtnBase";
import { Text } from "@utils/helper";
import RenderMeta from "@utils/RenderMeta";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
const NotFound = () => {
    const { t } = useTranslation("error-locale");
    const { push } = useRouter();
    return (<>
      <RenderMeta title={`${t(`error.title`)} | ${t("common-locale:aseel")}`}/>

      <div className="flex justify-center items-center h-screen">
        <div className="flex flex-col items-center text-center gap-3">
          <h1 className="text-8xl font-bold text-gray-800">404</h1>
          <h2 className="text-2xl font-semibold text-gray-800">
            {t("error.title")}
          </h2>
          <p className="text-lg text-gray-800">{t("error.description")}</p>
          <BtnBase onClick={() => push("/home")} variant="outlined" sx={{
            textTransform: "capitalize",
            borderRadius: "10px",
            height: "43px",
            padding: "0",
            px: "24px"
        }} className="!w-[140px] sm:!w-[240px]">
            <Text fontType="Expo_bok" weight="600" className="leading-5 !text-[12px] sm:!text-[16px] !text-[#0366FF] ">
              {t("error.back")}
            </Text>
          </BtnBase>
        </div>
      </div>
    </>);
};
export default NotFound;

    async function __Next_Translate__getStaticProps__19676fb446c__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/_error',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19676fb446c__ as getStaticProps }
  